<template>
  <div class="onboarding-page-content background-post-background" :class="{ mobile: $vuetify.display.mobile, 'one-column': oneColumn }">
    <div v-if="!oneColumn" class="d-flex align-center justify-center background-post-detail-10 px-10">
      <onboarding-media />
    </div>
    <fill-area :ignore-header-size="ignoreHeaderSize" :disabled="$vuetify.display.mobile" class="color-post-text">
      <div class="form-container d-flex justify-center" :class="{ 'align-center center-content': !$vuetify.display.mobile && !skipFormCentering }">
        <div class="form-content d-flex flex-column align-center fill-width">
          <app-logo v-if="!hideContentLogo" :size="80" />
          <onboarding-descriptions v-if="showOnboardingDescriptions" />
          <slot />
          <div class="buttons-container" :class="{ 'mt-8': !$vuetify.display.mobile, 'mt-4': $vuetify.display.mobile }">
            <slot name="buttons" />
            <app-download v-if="showAppDownload" />
          </div>
        </div>
      </div>
    </fill-area>
  </div>
</template>

<script>
import OnboardingDescriptions from "@/components/onboarding/OnboardingDescriptions.vue"
import OnboardingMedia from "@/components/onboarding/OnboardingMedia.vue"
import AppDownload from "@/components/AppDownload.vue"

export default {
  components: {
    AppDownload,
    OnboardingDescriptions,
    OnboardingMedia
  },
  props: {
    hideContentLogo: {
      type: Boolean,
      default: false
    },
    hideLeftSide: {
      type: Boolean,
      default: false
    },
    noPadding: {
      type: Boolean,
      default: false
    },
    showAppDownload: {
      type: Boolean,
      default: false
    },
    showOnboardingDescriptions: {
      type: Boolean,
      default: false
    },
    skipFormCentering: {
      type: Boolean,
      default: false
    },
    ignoreHeaderSize: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    oneColumn() {
      return this.hideLeftSide || this.$vuetify.display.mobile
    }
  }
}
</script>

<style lang="scss" scoped>
.onboarding-page-content {
  display: grid;
  grid-template-columns: 1fr 1fr;

  &.one-column {
    grid-template-columns: 1fr;
  }

  .form-container.center-content {
    min-height: 100%;
  }

  .buttons-container {
    width: 100%;

    :deep(.v-btn) {
      font-size: var(--font-size-title-small);
      height: 48px;
      margin-bottom: 16px;
    }
  }

  &.mobile {
    min-height: 100vh;
    height: 100%;

    .form-content {
      width: 100%;
      padding: 32px 16px 0 16px;
    }
  }

  :deep(.form-content) {
    width: 358px;
    padding: 32px 0;

    .v-field {
      min-height: 48px;
    }

    .onboarding-title {
      font-size: var(--font-size-title-very-big);
      font-weight: bold;
      line-height: 130%;
      margin-top: 16px;
      margin-bottom: 16px;
      text-align: center;
      word-break: break-word;
    }

    .v-form {
      width: 100%;
    }

    .form-label {
      margin-bottom: 8px;
      margin-top: 16px;
    }
  }
}
</style>
